import {
    LOGIN_EXITOSO,
    EDITAR_EXITOSO,
    LOGIN_ERROR,
    USUARIO_AUTENTICADO,
    CERRAR_SESION,
    MSG_RESET,
    CHANGE_ENFOQUE
} from '../../types';

export default (state, action) => {
    switch(action.type) {
        case LOGIN_EXITOSO:
        case EDITAR_EXITOSO:
            localStorage.setItem('token', action.payload.token);
            return {
                ...state,
                autenticado: true,
                token: action.payload.token,
                cargando: false
            }
        case CERRAR_SESION:
            localStorage.removeItem('token');
            return{
                ...state,
                autenticado: null,
                token: null,
                usuario: null,
                msg: null,
                cargando: false
            }
        case LOGIN_ERROR:
            return{
                ...state,
                msg: action.payload,
                cargando: false
            }
        case USUARIO_AUTENTICADO:
            return{
                ...state,
                autenticado:true,
                usuario: action.payload,
                cargando: false,
            }
        case MSG_RESET:
            return{
                ...state,
                msg: null
            }
        case CHANGE_ENFOQUE:
            return{
                ...state,
                enfoque: !state.enfoque
            }
        default:
            return state;
    }
}